import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';

/**
 * "Online" label with a blinking green dot on the right side of the chat header.
 * The pulse animation lives in index.css (`ai-online-dot`).
 */
export function OnlineIndicator() {
  const t = useFeatureTranslation('aiChat');

  return (
    <span className='mr-xs flex shrink-0 items-center gap-xs text-xs font-medium text-foreground-muted'>
      {t('online')}
      <span aria-hidden='true' className='ai-online-dot h-2 w-2 rounded-full bg-success-border' />
    </span>
  );
}
